import { iconMap } from 'src/components/lib/Icons';
import { IconComponent } from 'src/types/icon';

const useIcon = (icon?: string): IconComponent | null => {
  const Icon = icon ? iconMap.hasOwnProperty(icon) && iconMap[icon] : null;
  return Boolean(Icon) ? (Icon as IconComponent) : null;
};

export default useIcon;
